var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 213.77 132.84",
    style: {
      enableBackground: "new 0 0 213.77 132.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:#232643;}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:#562E60;}\r\n\t.st5{fill:#863B96;}\r\n\t.st6{fill:#0081B7;}\r\n\t.st7{fill:#00ABE3;}\r\n\t.st8{fill:#F47B20;}\r\n\t.st9{fill:#FAA22C;}\r\n\t.st10{fill:#1D693D;}\r\n\t.st11{fill:#40AE49;}\r\n\t.st12{fill:#A3282D;}\r\n\t.st13{fill:#E23240;}\r\n\t.st14{fill:#006292;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.9912,
    y1: 71.8975,
    x2: 94.2303,
    y2: 71.8975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#232643"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    style: {
      stopColor: "#262945"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    style: {
      stopColor: "#31324C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    style: {
      stopColor: "#424159"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    style: {
      stopColor: "#5B576D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6925,
    style: {
      stopColor: "#7E7A8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8527,
    style: {
      stopColor: "#B2AFBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "55.65,65.12 55.65,65.12 55.65,53.74 44.72,71.9 26.56,41.75 44.72,102.04 55.84,65.12 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.9912,
    y1: 83.5789,
    x2: 94.2303,
    y2: 83.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67499D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FBDED"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.72,102.04 66.96,65.12 55.84,65.12 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.72,102.04 66.96,65.12 55.84,65.12 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.9912,
    y1: 71.8975,
    x2: 94.2303,
    y2: 71.8975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67499D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FBDED"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "8.4,41.75 44.72,102.04 26.56,41.75 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.4,41.75 44.72,102.04 26.56,41.75 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "63.35,46.52 61.11,46.52 58.36,46.52 58.36,46.52 74.57,62.47 74.57,54.32 74.57,46.52 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "58.36,46.52 58.36,51.09 58.36,62.47 74.57,62.47 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "81.92,28.69 89.86,36.5 89.86,28.69 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "81.92,36.5 89.86,36.5 81.92,28.69 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.62,11.66 79.68,11.66 87.62,19.47 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.68,11.66 79.68,19.47 87.62,19.47 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "74.83,15.56 64.41,15.56 64.41,15.57 74.83,25.81 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "64.41,15.57 64.41,25.81 74.83,25.81 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "73.94,41.14 73.94,39.1 73.94,32.38 65.04,32.38 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "65.04,41.14 73.94,41.14 65.04,32.38 65.04,40 65.04,40.9 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "56.89,24.08 43.38,24.08 56.89,37.37 "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "43.38,24.08 43.38,24.08 43.38,24.08 43.38,37.37 56.89,37.37 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77,84.44c0,5.68,2.73,8.51,8.2,8.51c2.93,0,5.14-1.16,6.63-3.49h13.04c-2.63,8.54-9.22,12.81-19.75,12.81 c-3.23,0-6.19-0.47-8.87-1.42c-2.68-0.95-4.98-2.29-6.89-4.04c-1.91-1.75-3.39-3.83-4.43-6.26c-1.04-2.43-1.56-5.14-1.56-8.15 c0-3.1,0.5-5.91,1.49-8.4c0.99-2.5,2.41-4.62,4.25-6.37c1.84-1.75,4.06-3.09,6.67-4.04c2.61-0.95,5.55-1.42,8.83-1.42 c3.23,0,6.14,0.47,8.72,1.42c2.58,0.95,4.77,2.32,6.56,4.11c1.79,1.79,3.15,3.99,4.1,6.59c0.94,2.6,1.42,5.52,1.42,8.77v1.38H77 L77,84.44z M92.8,76.8c-0.45-1.84-1.37-3.32-2.76-4.44c-1.39-1.12-3.08-1.67-5.07-1.67c-2.09,0-3.79,0.53-5.1,1.6 c-1.32,1.07-2.15,2.57-2.5,4.51H92.8L92.8,76.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.59,63.56v34.78c0,2.09-0.12,3.95-0.37,5.6c-0.25,1.65-0.6,3.1-1.04,4.37c-0.6,1.6-1.53,3.09-2.79,4.47 c-1.27,1.38-2.79,2.58-4.58,3.6c-1.79,1.02-3.81,1.82-6.07,2.4c-2.26,0.58-4.71,0.87-7.34,0.87c-2.98,0-5.71-0.36-8.2-1.09 c-2.48-0.73-4.66-1.73-6.52-3.02c-1.86-1.29-3.39-2.79-4.58-4.51c-1.19-1.72-1.99-3.6-2.38-5.64h15.2c0.94,2.47,3.08,3.71,6.41,3.71 c2.83,0,5.01-0.78,6.52-2.33c1.52-1.55,2.27-3.71,2.27-6.48v-3.57c-0.99,0.92-1.95,1.69-2.87,2.29c-0.92,0.61-1.85,1.1-2.79,1.49 s-1.94,0.67-2.98,0.84c-1.04,0.17-2.19,0.25-3.43,0.25c-2.73,0-5.24-0.46-7.53-1.38c-2.29-0.92-4.26-2.21-5.92-3.86 c-1.66-1.65-2.96-3.63-3.88-5.93c-0.92-2.3-1.38-4.86-1.38-7.68c0-2.86,0.5-5.52,1.49-7.97c0.99-2.45,2.35-4.58,4.06-6.4 c1.71-1.82,3.75-3.25,6.11-4.29c2.36-1.04,4.93-1.56,7.71-1.56c4.52,0,8.32,1.65,11.4,4.95v-3.93H151.59L151.59,63.56z  M121.33,82.04c0,1.21,0.22,2.34,0.67,3.38c0.45,1.04,1.06,1.95,1.83,2.73c0.77,0.78,1.69,1.38,2.76,1.82 c1.07,0.44,2.22,0.65,3.47,0.65c1.19,0,2.32-0.22,3.39-0.65c1.07-0.44,1.99-1.04,2.76-1.82c0.77-0.78,1.39-1.69,1.86-2.73 c0.47-1.04,0.71-2.15,0.71-3.31c0-1.21-0.24-2.33-0.71-3.35c-0.47-1.02-1.11-1.92-1.9-2.69c-0.79-0.78-1.73-1.38-2.79-1.82 c-1.07-0.44-2.17-0.65-3.32-0.65c-1.19,0-2.31,0.23-3.35,0.69c-1.04,0.46-1.96,1.07-2.76,1.82c-0.79,0.75-1.43,1.64-1.9,2.66 C121.57,79.78,121.33,80.88,121.33,82.04L121.33,82.04z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184.18,63.56h13.56v37.33h-13.56v-4.15c-2.88,3.54-6.78,5.31-11.7,5.31c-2.78,0-5.34-0.5-7.68-1.49 c-2.33-0.99-4.37-2.39-6.11-4.18c-1.74-1.79-3.09-3.9-4.06-6.33c-0.97-2.43-1.45-5.07-1.45-7.93c0-2.67,0.47-5.2,1.42-7.6 c0.94-2.4,2.26-4.5,3.95-6.29c1.69-1.79,3.7-3.21,6.04-4.26c2.33-1.04,4.92-1.56,7.75-1.56c4.77,0,8.72,1.63,11.85,4.88V63.56 L184.18,63.56z M167.19,82.11c0,1.21,0.22,2.34,0.67,3.38c0.45,1.04,1.06,1.95,1.83,2.73s1.69,1.38,2.76,1.82 c1.07,0.44,2.22,0.65,3.47,0.65c1.19,0,2.32-0.22,3.39-0.65c1.07-0.44,1.99-1.04,2.76-1.82c0.77-0.78,1.39-1.67,1.86-2.69 c0.47-1.02,0.71-2.11,0.71-3.27c0-1.16-0.24-2.27-0.71-3.31c-0.47-1.04-1.09-1.95-1.86-2.73c-0.77-0.78-1.69-1.38-2.76-1.82 c-1.07-0.44-2.2-0.65-3.39-0.65c-1.24,0-2.4,0.22-3.47,0.65c-1.07,0.44-1.99,1.04-2.76,1.82s-1.38,1.66-1.83,2.66 C167.42,79.87,167.19,80.95,167.19,82.11L167.19,82.11z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegaLogo);
export default __webpack_public_path__ + "static/media/vega-logo.eabfe5dc09b6c7d9d442c32e76330f76.svg";
export { ForwardRef as ReactComponent };